import { runInnerFunction } from "../../compatManager";
import { getNodes, isNullValue, RPWDataReader, XMLCheckNullAttributeTextAreaFieldValue, XMLCheckNullAttributeValue } from "../../livedataFuncs";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject } from "../../redux/reducer";
import { store } from "../../redux/store";
import { lddGlobalSessionInfo } from "../navigationTypes";
import { downloadFile, view_doc_MakeASaveAsName_CleanUp } from "../utils/utilFuncs";

export type TVWebInfo = {
    useTraining?: any;
    "MatterNumber": string,
    "Reline": string,
    "AppID": number,
    "RegistryOfficeID": string,
    "payload": [
        {
            "file"?: string,
            "project"?: string,
            "xml"?: string
        }?,
    ],
    acct?: string,
    user?: string,
    pass?: string,
}

declare global {
    interface Window {
        useTrainingTVWeb: boolean;
        notAllowedSend: boolean;
    }
}

window.useTrainingTVWeb = true;
window.notAllowedSend = false;

declare function DoExportToTeraview(lroNum, docketId, docketName, xmlname, xmlstr);
declare let TVclientFuncs;
declare let lddGlobalSettings;

export async function prepareTeraViewExport(ExportAction: string, DataReaderObj: RPWDataReader, livedataRoot: ajaxslt.XNode, setAdditionalInfo: (string) => void) {
    let clonenode: ajaxslt.XNode = livedataRoot.cloneNode(true);

    let docketIdFlag: string = DataReaderObj.getDockerIdOverwriteFlag();
    let docketId: string = DataReaderObj.getDockerId();
    if(docketIdFlag === '' || docketIdFlag === '0' || docketIdFlag === null || docketIdFlag === undefined){
        docketId = DataReaderObj.getFileNumber();
    }
    if (docketId === null || docketId === undefined || docketId === '') {
        alert("Please Indicate the Docket Id");
        return;
    }

    let docketNameFlag: string = DataReaderObj.getDockerNameOverwriteFlag();
    let docketName: string = DataReaderObj.getDockerName();
    if(docketNameFlag === '' || docketNameFlag === '0' || docketNameFlag === null || docketNameFlag === undefined){
        docketName = DataReaderObj.getReline();
    }
    if (docketName === '' || docketName === null || docketName === undefined) {
        alert("Please Indicate the Docket Name");
        return;
    }

    let lroNum: string = DataReaderObj.getLRONumber();
    let state: lddStateObject = store.getState();
    let sid: string = state?.SessionID;
    if (lroNum === '' || lroNum === null || lroNum === undefined) {
        alert("Please Indicate the LRO");
        return;
    }
    let TVWebInfo: TVWebInfo = {
        "MatterNumber": docketId,
        "Reline": docketName,
        "AppID": 0,
        "RegistryOfficeID": lroNum,
        "payload": []
    }
    let CheckDataString: string = '';
    let ConsiderationAmount: string = XMLCheckNullAttributeValue(livedataRoot, 'ConsiderationAmount', '1');
    // transferees
    let TransfereeNodes: ajaxslt.XNode[] = getNodes(livedataRoot, "Purchaser[not(not(@TransfereeName)) and not(@TransfereeName='')]");
    let TransfereeAddress: string = '';
    let TransfereeCorpSO: string = '';
    let Transferees: string = '';
    let TransfereesComma: number = 0;
    let TransfereesBirthDate: number = 0;

    if (TransfereeNodes.length > 0) {
        if (TransfereeNodes[0].getAttribute('Gender') == 'Corporation') {
            let TransfereeSONodes: ajaxslt.XNodeList<ajaxslt.XNode> = TransfereeNodes[0].selectNodes('SignOff');
            TransfereeCorpSO = XMLCheckNullAttributeValue(TransfereeSONodes[0], 'SignOffName', '1');
        }
        for (let i = 0; i < TransfereeNodes.length; i++) {
            if (TransfereeNodes[i].getAttribute('OnTitle') == '1') {
                let tmpTransfereeName: string = TransfereeNodes[i].getAttribute('TransfereeName');
                if (tmpTransfereeName != null && tmpTransfereeName != '')
                    Transferees = '1';
                if (TransfereeNodes[i].getAttribute('AddressForService') != null && TransfereeNodes[i].getAttribute('AddressForService') != '' && TransfereeNodes[i].getAttribute('AddressForService').length > 6)
                    TransfereeAddress = '1';

                if (TransfereeNodes[i].getAttribute('Gender') != 'Corporation') {
                    if (tmpTransfereeName.indexOf(",") == -1) TransfereesComma++;
                }
            }
        }
    }
    // transferors 
    let TransferorNodes: ajaxslt.XNode[] = getNodes(livedataRoot, "Vendor");
    let TransferorCorpSO: string = '';
    if (TransferorNodes.length > 0) {
        if (TransferorNodes[0].getAttribute('Gender') == 'Corporation') {
            let TransferorSONodes: ajaxslt.XNodeList<ajaxslt.XNode> = TransferorNodes[0].selectNodes('SignOff');
            TransferorCorpSO = XMLCheckNullAttributeValue(TransferorSONodes[0], 'SignOffName', '1');
        }
    }
    // mortgages
    let MortgageNodes: ajaxslt.XNode[] = getNodes(livedataRoot, "Mortgage");
    let MortgageAmount: string = '';
    let MortgageeAddressForService: string = '';
    if (MortgageNodes.length > 0) {
        for (let i = 0; i < MortgageNodes.length; i++) {
            if (MortgageNodes[i].getAttribute('Lender') != null && MortgageNodes[i].getAttribute('Lender') != '') {
                if (MortgageAmount != '1')
                    MortgageAmount = XMLCheckNullAttributeValue(MortgageNodes[i], 'Amount', '1');
                let MortgageLenderNode = MortgageNodes[i].selectSingleNode('Lender');
                if (MortgageeAddressForService != '1') {
                    if (MortgageNodes[i].getAttribute('IsVTB') == '1')
                        MortgageeAddressForService = XMLCheckNullAttributeTextAreaFieldValue(livedataRoot, 'VendorAddress', '1');
                    else {
                        if (MortgageLenderNode != null) {
                            if (MortgageLenderNode.getAttribute('ServiceAddress') == null || MortgageLenderNode.getAttribute('ServiceAddress') == '' || MortgageLenderNode.getAttribute('ServiceAddress').length < 6)
                                MortgageeAddressForService = XMLCheckNullAttributeTextAreaFieldValue(MortgageLenderNode, 'Address', '1');
                            else
                                MortgageeAddressForService = XMLCheckNullAttributeTextAreaFieldValue(MortgageLenderNode, 'ServiceAddress', '1');
                        }
                    }
                }
            }
        }
    }
    let MtgPartiesFromAddressForService: string;
    if (DataReaderObj.getPSM() == 'S')
        MtgPartiesFromAddressForService = XMLCheckNullAttributeTextAreaFieldValue(livedataRoot, 'VendorAddress', '1')
    if (DataReaderObj.getPSM() == 'P' || DataReaderObj.getPSM() == 'M') {
        if (DataReaderObj.getResideAtProperty() == '1')
            MtgPartiesFromAddressForService = XMLCheckNullAttributeTextAreaFieldValue(livedataRoot, 'PropertyAddress', '1')
        else
            MtgPartiesFromAddressForService = XMLCheckNullAttributeTextAreaFieldValue(livedataRoot, 'PurchaserAddress', '1')
    }
    // discharges
    let DischargeNodes: ajaxslt.XNode[] = getNodes(livedataRoot, "Defect");
    let DischargeInstrumentNumber: string = '';
    let DischargeAddressForService: string = '';
    let DischargeSO: string = '';

    if (DischargeNodes.length > 0) {
        for (let i = 0; i < DischargeNodes.length; i++) {
            if (DischargeNodes[i].getAttribute('type') == '32_2') {
                let DischargeDataNode: ajaxslt.XNode = DischargeNodes[i].selectSingleNode('Data');
                if (DischargeInstrumentNumber != '1') {
                    DischargeInstrumentNumber = XMLCheckNullAttributeValue(DischargeDataNode, 'InstrumentNumber', '1');
                }

                let DischargeLenderNode: ajaxslt.XNode = DischargeDataNode.selectSingleNode('Lender');
                if (DischargeAddressForService != '1') {
                    if (DischargeLenderNode != null) {
                        if (DischargeLenderNode.getAttribute('ServiceAddress') == null || DischargeLenderNode.getAttribute('ServiceAddress') == '') {
                            DischargeAddressForService = XMLCheckNullAttributeTextAreaFieldValue(DischargeLenderNode, 'Address', '1');
                        } else {
                            DischargeAddressForService = XMLCheckNullAttributeTextAreaFieldValue(DischargeLenderNode, 'ServiceAddress', '1');
                        }
                    }
                }
                if (DischargeLenderNode != null && DischargeLenderNode.getAttribute('PrivateLender') != '1') {
                    let DischargeLenderSONodes: ajaxslt.XNodeList<ajaxslt.XNode> = DischargeLenderNode.selectNodes('SigningAuthority');
                    if (DischargeSO != '1') {
                        DischargeSO = XMLCheckNullAttributeValue(DischargeLenderSONodes[i], 'Name', '1');
                    }
                }
            }
        }
    }
    let CondoDwelling: string = '';
    let completePIN: number = 0;
    let incompletePIN: number = 0;
    let PropertyType: string = XMLCheckNullAttributeValue(livedataRoot, 'PropertyType', '1');
    if (PropertyType != '1') {
        let LegalDescNode: ajaxslt.XNode[] = getNodes(livedataRoot, 'LegalDescriptionInput');
        if (LegalDescNode != null) {
            if (DataReaderObj.getPropertyType() == 'Condo') {
                let UnitNodes: ajaxslt.XNode[] = getNodes(LegalDescNode[0], "Unit[not(not(@Type)) and not(@Type='')]");
                for (let x = 0; x < UnitNodes.length; x++) {
                    if (!isNullValue(UnitNodes[x], 'PINBlock') && !isNullValue(UnitNodes[x], 'PINProperty')) completePIN++;
                    else incompletePIN++;
                }

                CondoDwelling = XMLCheckNullAttributeValue(UnitNodes[0], 'Type', '1');
            }
            else {
                let LotNode: ajaxslt.XNode = getNodes(LegalDescNode[0], 'Lot')[0];
                if (LotNode != null) {
                    let LotPINNodes = getNodes(LotNode, "LotPIN[not(not(@PINBlock)) and not(@PINBlock='')]");
                    for (let x = 0; x < LotPINNodes.length; x++) {
                        if (!isNullValue(LotPINNodes[x], 'PINBlock') && !isNullValue(LotPINNodes[x], 'PINProperty')) completePIN++;
                        else incompletePIN++;
                    }
                }
            }
        }
    }
    if (DataReaderObj.getCreateTransfer() == '1') {
        if (ConsiderationAmount == '1')
            CheckDataString = CheckDataString + 'You Must Enter the Consideration \n';
        if (Transferees == '')
            CheckDataString = CheckDataString + 'At Least 1 Transferee On Title is Required \n';
        if (TransfereeAddress == '')
            CheckDataString = CheckDataString + 'An Address for Service for at Least 1 Transferee is Required \n';
        if (TransfereesComma > 0)
            CheckDataString = CheckDataString + TransfereesComma + " Transferee(s) On Title do not have a comma in the name, eg. Last Name, First Name \n";
        if (TransfereesBirthDate > 0)
            CheckDataString = CheckDataString + TransfereesBirthDate + " Transferee(s) On Title is missing a Birth Date \n";
        if (DataReaderObj.getVendorAddress() == null || DataReaderObj.getVendorAddress() == '' || DataReaderObj.getVendorAddress().length < 6)
            CheckDataString = CheckDataString + (((DataReaderObj.getPSM() == 'P')) ? 'Transferor(s) Address for Service (Post Closing) is Required \n' : 'A Vendor Address is Required \n');
        /*if(TransferorCorpSO=='1')
            CheckDataString=CheckDataString + 'You Must Enter the Signing Officer(s) for the Transferor  \n';
        */	if (PropertyType == '1')
            CheckDataString = CheckDataString + 'You Must Select a PropertyType  \n';
        if (CondoDwelling == '1')
            CheckDataString = CheckDataString + 'You Must Enter the Unit Type, Number, Level and PIN for each Condo Unit  \n';
        if (completePIN == 0)
            CheckDataString = CheckDataString + 'You Must Enter at least 1 PIN fully \n';
        else if (incompletePIN != 0)
            CheckDataString = CheckDataString + 'At Least 1 PIN is not entered fully \n';
        if (CheckDataString != '')
            alert(CheckDataString);
        else {
            let response = await xmlRunXSLTFileServer(sid, livedataRoot, 'xml/public/transfer.xslt', "POST", '1',
                {
                    "Content-Type": "text/plain"
                }
            );
            let xmlstr: string = await response.text();
            TVWebInfo.payload.push({ "file": "transfer.xml", "project": "transfer", "xml": xmlstr });
            if (ExportAction == 'Export')
                DoExportToTeraview(lroNum, docketId, docketName, 'transfer.xml', xmlstr);
            else if (ExportAction == 'SaveXML') {
                SaveXMLDataFile(livedataRoot, xmlstr, 'Transfer');
            }
            else if (ExportAction == 'ViewXML') {
                OpenXMLDataWindow(livedataRoot, xmlstr, 'Transfer');
            }
        }
    }
    if (DataReaderObj.getCreateCharge() == '1') {
        CheckDataString = '';
        CheckDataString = '';
        if (MortgageAmount == '1')
            CheckDataString = CheckDataString + 'You Must have a Principal Amount for each Mortgage  \n';
        if (MtgPartiesFromAddressForService == '1')
            CheckDataString = CheckDataString + 'You Must enter the Address for Service of the Mortgagor(s)  \n';
        /*	if(TransfereeCorpSO=='1')
            CheckDataString=CheckDataString + 'You Must Enter the Signing Officer(s) for the Mortgagor  \n';
        */	if (MortgageeAddressForService == '1')
            CheckDataString = CheckDataString + 'You Must enter the Address for Service of each Mortgagee  \n';
        if (PropertyType == '1')
            CheckDataString = CheckDataString + 'You Must Select a PropertyType  \n';
        if (CondoDwelling == '1')
            CheckDataString = CheckDataString + 'You Must Enter the Unit Type, Number, Level and PIN for each Condo Unit  \n';
        if (completePIN == 0)
            CheckDataString = CheckDataString + 'You Must Enter at least 1 PIN fully \n';
        else if (incompletePIN != 0)
            CheckDataString = CheckDataString + 'At Least 1 PIN is not entered fully \n';
        if (CheckDataString != '')
            alert(CheckDataString);
        else {
            let response = await xmlRunXSLTFileServer(sid, livedataRoot, 'xml/public/charge.xslt', "POST", '1',
                {
                    "Content-Type": "text/plain;charset=UTF-8"
                }
            );
            let xmlstr: string = await response.text();
            TVWebInfo.payload.push({ "file": "charge.xml", "project": "charge(s)", "xml": xmlstr });
            if (ExportAction == 'Export')
                DoExportToTeraview(lroNum, docketId, docketName, 'charge.xml', xmlstr);
            else if (ExportAction == 'SaveXML') {
                SaveXMLDataFile(livedataRoot, xmlstr, 'Charge');
            }
            else if (ExportAction == 'ViewXML') {
                OpenXMLDataWindow(livedataRoot, xmlstr, 'Charge');
            }
        }
    }
    if (DataReaderObj.getCreateDischarge() == '1') {
        CheckDataString = '';

        if (DischargeInstrumentNumber == '1')
            CheckDataString = CheckDataString + 'You Must have a Source Instrument Number for each Discharge  \n';
        if (DischargeAddressForService == '1')
            CheckDataString = CheckDataString + 'You Must enter the Address for Service of each Mortgage Lender  \n';
        /*	if(DischargeSO=='1')
        CheckDataString=CheckDataString + 'You Must Enter the Signing Officer(s) for any Non-Private Lenders   \n';
        */

        if (PropertyType == '1')
            CheckDataString = CheckDataString + 'You Must Select a PropertyType  \n';
        if (CondoDwelling == '1')
            CheckDataString = CheckDataString + 'You Must Enter the Unit Type, Number, Level and PIN for each Condo Unit   \n';
        if (completePIN == 0)
            CheckDataString = CheckDataString + 'You Must Enter at least 1 PIN fully \n';
        else if (incompletePIN != 0)
            CheckDataString = CheckDataString + 'At Least 1 PIN is not entered fully \n';
        if (CheckDataString != '')
            alert(CheckDataString);
        else {
            let response = await xmlRunXSLTFileServer(sid, livedataRoot, 'xml/public/discharge.xslt', "POST", '1',
                {
                    "Content-Type": "text/plain"
                }
            );
            let xmlstr: string = await response.text();
            TVWebInfo.payload.push({ "file": "discharge.xml", "project": "discharge", "xml": xmlstr });
            // alert(xmlstr, true);
            if (ExportAction == 'Export')
                DoExportToTeraview(lroNum, docketId, docketName, 'discharge.xml', xmlstr);
            else if (ExportAction == 'SaveXML')
                SaveXMLDataFile(livedataRoot, xmlstr, 'Discharge');
            else if (ExportAction == 'ViewXML')
                OpenXMLDataWindow(livedataRoot, xmlstr, 'Discharge');
        }
    }

    let DocumentGeneralNodes: ajaxslt.XNode[] = getNodes(livedataRoot, 'DocumentGeneral');
    for (let i = 0; i < DocumentGeneralNodes.length; i++) {
        if (DocumentGeneralNodes[i].getAttribute('CreateDocumentGeneral') == '1') {
            CheckDataString = '';
            if (CheckDataString != '')
                alert(CheckDataString);
            else {
                let response = await xmlRunXSLTFileServer(sid, DocumentGeneralNodes[i], 'xml/public/documentgeneral.xslt', "POST", '1',
                    {
                        "Content-Type": "text/plain"
                    }
                );
                let xmlstr: string = await response.text();
                TVWebInfo.payload.push({ "file": "docgen.xml", "project": (DocumentGeneralNodes[i].getAttribute('type')).substring(0, 30), "xml": xmlstr });

                if (ExportAction == 'Export')
                    DoExportToTeraview(lroNum, docketId, docketName, 'documentgeneral.xml', xmlstr);
                else if (ExportAction == 'SaveXML') {
                    SaveXMLDataFile(livedataRoot, xmlstr, DocumentGeneralNodes[i].getAttribute('type'));
                }
                else if (ExportAction == 'ViewXML')
                    OpenXMLDataWindow(livedataRoot, xmlstr, DocumentGeneralNodes[i].getAttribute('type'));
            }
        }
    }
    if (DataReaderObj.getbApplyToSpecificBuilding() == "1" && DataReaderObj.getBuildingNumToMerge() > "") {
        let oldLegalDescriptionInput: ajaxslt.XNode = clonenode.selectSingleNode("LegalDescriptionInput");
        let newLegalDescriptionInput: ajaxslt.XNode = livedataRoot.selectSingleNode("LegalDescriptionInput");

        if (oldLegalDescriptionInput && newLegalDescriptionInput)
            livedataRoot.replaceChild(oldLegalDescriptionInput, newLegalDescriptionInput);

        let oldConsiderationAmt: string = clonenode.getAttribute("ConsiderationAmount");
        if (oldConsiderationAmt > "") livedataRoot.setAttribute("ConsiderationAmount", oldConsiderationAmt);
    }
    if (TVWebInfo.payload.length) {
        if (ExportAction == 'ExportTVWeb') {
            setAdditionalInfo('')
            TVclientFuncs.resetLoadStatus();
            let lawyernode: ajaxslt.XNode = livedataRoot.selectSingleNode('lawyer');
            let tpanode: ajaxslt.XNode = lawyernode ? lawyernode.selectSingleNode('ThirdPartyAcounts') : null;
            let tnode: ajaxslt.XNode = tpanode ? tpanode.selectSingleNode("Account[@Party='Teraview']") : null;
            if (tnode == null) {
                let tmpDOM;
                await fetch(`GetThirdPartyInfo.asp?SessionID=${sid}`).then(
                    (data) => {
                        tmpDOM = data;
                    }
                );
                let resText = await tmpDOM.text();
                // need to change this once ajaxslt is properly integrated
                tmpDOM = runInnerFunction('ReactShell.reactLDDCreateXMLDocument', resText);
                if (tmpDOM != null && tmpDOM.documentElement != null && tmpDOM.documentElement.hasChildNodes()) {
                    tnode = tmpDOM.documentElement.selectSingleNode("User/ThirdPartyAcounts/Account[@Party='Teraview']");
                    if (tnode && tnode.getAttribute("isAccountOverWrite") != "1") {
                        let firmtnode = tmpDOM.documentElement.selectSingleNode("Firm/ThirdPartyAcounts/Account[@Party='Teraview']");
                        if (firmtnode) {
                            let firmaccount = firmtnode.getAttribute("AccountName");
                            if (firmaccount > "") {
                                tnode.setAttribute("Account", firmaccount);
                            }
                        }
                    }
                }
            }
            let account: string = null;
            let username: string = null;
            let password: string = null;
            if (tnode) {
                if (tnode.getAttribute('Account') != null && tnode.getAttribute('Account') > '') {
                    account = tnode.getAttribute('Account');
                }
                if (tnode.getAttribute('UserName') != null && tnode.getAttribute('UserName') > '') {
                    username = tnode.getAttribute('UserName');
                }
                if (tnode.getAttribute('TeraviewPassword') != null && tnode.getAttribute('TeraviewPassword') > '') {
                    password = tnode.getAttribute('TeraviewPassword');
                }
            }
            if (lddGlobalSettings && lddGlobalSettings.LDDExtVersion > "" && false) {
            } else {
                // server call
                if (window.notAllowedSend) {
                    alert('Please check your Teraview credentials and update them in User Settings under the Tools menu, if necessary. Continued attempts to upload with the current information may lock your Teraview account.');
                }
                else {
                    let missingFields: string[] = [];
                    if (account == null || account == "")
                        missingFields.push("Teraview Account");
                    if (username == null || username == "")
                        missingFields.push("Teraview Username");
                    if (!window.useTrainingTVWeb && (password == null || password == ""))
                        missingFields.push("Teraview Password");
                    if (window.useTrainingTVWeb && (TVWebInfo.RegistryOfficeID != '20'))
                        missingFields.push("LRO need to be 20 for Teraview Training Site");
                    if (missingFields.length > 0) {
                        let alertMSG = "Please enter the following required fields: \n";
                        for (let _i = 0, missingFields_1 = missingFields; _i < missingFields_1.length; _i++) {
                            let field = missingFields_1[_i];
                            alertMSG += field + "\n";
                        }
                        alert(alertMSG);
                        return;
                    }
                    TVWebInfo.acct = account;
                    TVWebInfo.user = username;
                    TVWebInfo.useTraining = window.useTrainingTVWeb;
                    if (!window.useTrainingTVWeb) {
                        TVWebInfo.pass = password;
                    }
                    let firmID: string = livedataRoot.getAttribute('LawyerID');
                    let url = `/browserapi/${firmID}/rwon/tvweb/upload?SessionID=${sid}`;
                    let headers = { "Content-Type": "application/json" };
                    let xmlHttp = await fetch(url, {
                        headers: headers,
                        method: "POST",
                        body: JSON.stringify(TVWebInfo),
                    })
                    let res: string = await xmlHttp.text();
                    let response = JSON.parse(res);
                    if (response.ok) {
                        alert('File(s) uploaded!');
                    }
                    else {
                        if (response.error > "" && response.error.indexOf('login failed: Login Failed - Invalid Information') != -1) {
                            window.notAllowedSend = true;
                        } else if (response.error > "" && response.error == "timeout") {
                            alert("Your session timed out. Please check your instrument(s) status directly on the Teraview\xAE website.")
                        } else {
                            alert(response.error.substring(14));
                        }
                        // additional info stuff
                        if(response.additionalInfo && response.additionalInfo.indexOf('data:image/png;base64') != -1) {
                            setAdditionalInfo(response.additionalInfo)
                        }
                    }
                }
            }
        }
    }
}

async function xmlRunXSLTFileServer(sid: string, node: ajaxslt.XNode, xslpath: string, method: string, serverlocation: string, headers) {
    let xmlstr;
    await fetch(`xml2html.asp?xsl=${encodeURIComponent(xslpath)}&dataxpath=${encodeURIComponent(FindNodeXPathInDocument(node))}&serverlocation=${serverlocation}&SessionID=${sid}&compat=1`,
        {
            headers: headers,
            method: method,
            body: node.ownerDocument.xml
        }).then((data) => {
            xmlstr = data;
        });
    return xmlstr;
}
function FindNodeXPathInDocument(node: ajaxslt.XNode) {
    let curNode: ajaxslt.XNode = node;
    let xpath: string = FindNodePositiontPath(node);
    while (curNode.parentNode.nodeType == 1) {
        curNode = curNode.parentNode;
        xpath = `${FindNodePositiontPath(curNode)}/${xpath}`;
    }
    return `/${xpath}`;
}
function FindNodePositiontPath(node: ajaxslt.XNode) {
    let curNode: ajaxslt.XNode = node;
    let curName: string = node.nodeName;
    let pos = 1;
    while (curNode.previousSibling) {
        if (curNode.previousSibling.nodeType == 1 && curNode.previousSibling.nodeName == curName)
            ++pos;
        curNode = curNode.previousSibling;
    }
    return `${curName}[${pos}]`;
}

function SaveXMLDataFile(TPAppXMLNode: ajaxslt.XNode, xmlstr: string, DocumentType: string) {
    let MatterNumber: string = TPAppXMLNode.getAttribute("MatterNumber");
    // Get rid of / \ " ' : ? ! + #
    MatterNumber = view_doc_MakeASaveAsName_CleanUp(MatterNumber);
    let filename: string = MatterNumber + " - " + DocumentType;
    downloadFile(filename, xmlstr, "text/xml");
}

function OpenXMLDataWindow(TPAppXMLNode: ajaxslt.XNode, xmlstr: string, DocumentType: string) {
    var w = window.open("", "inheritwin", "toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes,left=100,top=150,width=600,height=500");
    w.document.write(`
    <table cellspacing=0 cellpadding=0>
        <tr><td align=center><b>${DocumentType}</b><br></td></tr>
    </table>
        <textarea rows=50 cols=70>${xmlstr}</textarea>
    `);
}

export function showDischargeFunction(livedataRoot: ajaxslt.XNode): boolean {
    let DefectNodes: ajaxslt.XNode[] = getNodes(livedataRoot, "Defect");
    for (let i = 0; i < DefectNodes.length; i++) {
        if (DefectNodes[i].getAttribute('type') === '32_2')
            return true;
    }
    return false;
}

export function setTrainingTVWeb(flag: boolean) {
    window.useTrainingTVWeb = flag;
}

export function checkForCreateDocumentGeneral(node: ajaxslt.XNode[]): boolean { 
    for(let i = 0; i < node.length; i++) {
        if(node[i].getAttribute('CreateDocumentGeneral') === '1'){
            return true;
        }
    }
    return false;
}